// extracted by mini-css-extract-plugin
export default {"base":"Indicator_base__7OS7P","button":"Indicator_button__9HD1U","indicator":"Indicator_indicator__1CEtj","active":"Indicator_active__z07EU"};